import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "./Shared";
import { Logo, Plus, Share,MoreVertical } from "../assets/icons";
import { SCREEN_WIDTH } from "../Utils/Dimensions";
const texts = [
  "افزودن اپلیکیشن پیشرو تابلو طلا",
  "با این کار همواره می توانید به آسانی از خدمات تابلو طلا استفاده کنید",
  "۱. روی دکمه Share در نوار پایین کلیک کنید",
  "۲. گزینه Add to Home Screen را انتخاب کنید",
  "۳. در قسمت بالا روی Add کلیک کنید",
  "۱. روی دکمه تنظیمات در بالای صفحه سمت راست کلیک کنید",
  "۳. روی Add کلیک کنید",


];
const iconWidth = 16;
const AddToHome = () => {
  const [, setisVisible] = useState(true);
  const [OS, setOS] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    getOS();
  }, []);
  function getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }

    setOS(os);
  }
  function onClose() {
    setisVisible(false);
    dispatch({
      type: "IS_ADD_TO_HOME",
      payload: true,
    });
  }
  return (
    <div className="addToHomeContainer">
      <div>
        <div className="_logo">
          <Logo width={SCREEN_WIDTH * 0.2} height={SCREEN_WIDTH * 0.15} />
        </div>
        <p className="_title">{texts[0]}</p>
        <p className="_subTitle">{texts[1]}</p>
      </div>
      <div>
        {OS === "Android" ? (
          <>
            <div className="_rowSpace">
              <p className="_subTitle _colorWhite">{texts[5]}</p>
              <MoreVertical width={iconWidth} height={iconWidth}  />
            </div>
            <div className="_rowSpace">
              <p className="_subTitle _colorWhite">{texts[3]}</p>
              <Plus width={iconWidth} height={iconWidth} />
            </div>
            <div className="_rowSpace">
              <p className="_subTitle _colorWhite">{texts[6]}</p>
              <p className="_addText">Add</p>
            </div>
          </>
        ) : OS === "iOS" ? (
          <>
            <div className="_rowSpace">
              <p className="_subTitle _colorWhite">{texts[2]}</p>
              <Share width={iconWidth} height={iconWidth} stroke="#147efb" />
            </div>
            <div className="_rowSpace">
              <p className="_subTitle _colorWhite">{texts[3]}</p>
              <Plus width={iconWidth} height={iconWidth} />
            </div>
            <div className="_rowSpace">
              <p className="_subTitle _colorWhite">{texts[4]}</p>
              <p className="_addText">Add</p>
            </div>
          </>
        ) : (
          <p className="_subTitle">در صورتی که از تلفن همراه استفاده کنید می توانید وب اپ تابلو طلا را به صفحه اصلی اضافه کنید</p>
        )}
      </div>
      <Button className="_button" onClick={onClose}>
        <p>متوجه شدم</p>
      </Button>
    </div>
  );
};

export default AddToHome;
